import React, { useState } from "react";
import { FaCog } from "react-icons/fa";
import SettingsModal from "../../pages/SettingsModal/SettingsModal";
import ActionButton from "./ActionButton";

const SettingsButton = () => {
  const [showModal, setShowModal] = useState(false);

  const openSettings = () => setShowModal(true);
  const closeSettings = () => setShowModal(false);

  return (
    <>
      <ActionButton icon={FaCog} tooltip="Settings" onClick={openSettings} />
      <SettingsModal show={showModal} handleClose={closeSettings} />
    </>
  );
};

export default SettingsButton;
